import Vue from "vue";
import Vuex from "vuex";
// import TimeManager from "../../Services/TimeManager";

Vue.use(Vuex);

export default {
  name: "time",
  state: {
  
  },
  getters: {
    
  },
  mutations: {
   
  },
  actions: {},
};
